<template>
  <div class="flip-main">
    <div class="flip-top">
      <div class="flip-top-text">
        <span>{{getTip}}</span>
        <div class="flip-spend" v-show="!shuffle">
          <span class="flip-cost" v-if="getPrice">{{getPrice}}</span>
          <span class="flip-cost" v-else-if="$bus.actInfo.canRefresh">
            {{ $bus.actInfo.useFreeRefresh >= $bus.actInfo.allFreeRefresh ? $bus.actInfo.refreshCost : $bus.transify['FLIP_FREE']}}
          </span>
          <i class="diamond" v-show="($bus.actInfo.useFreeRefresh >= $bus.actInfo.allFreeRefresh && $bus.actInfo.canRefresh)|| getPrice"></i>
        </div>
      </div>
      <div class="flip-skip-anime" @click="skipAnime">
        <i class="skip-radio" :class="$bus.skipAnime ? 'active' : ''"></i>
        <span class="skip-text">{{$bus.transify['FLIP_SKIP_ANIMATION']}}</span>
      </div>
    </div>
    <div ref="flip" class="flip-card-inner">
      <template v-for="(item, index) in CardList" >
        <div class="flip-item" :class="'flip-item-' + (index + 1)" :key="item.index">
          <keep-alive>
            <Card class="flip-card"
            :class="[startShuffle ? 'front-flip': '']"
            :type="item.type"
            :src="item.src"
            :name="item.name"
            :status="item.status"
            :nums="item.num"
            :float="floatAnime" />
          </keep-alive>
          <ff-button v-show="item.status !== 1 && !startShuffle" class="flip-item-btn" type="flip" @btnEvent="flipCard(index)">
            <span class="flip-btn-text">{{$bus.transify['FLIP_FLIP']}}</span>
          </ff-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Card from '@/components/main/card.vue'
import ffButton from '@/components/common/Button.vue'
import { compare } from '@/utils/assist'
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  components: {
    Card,
    ffButton
  },
  props: {
    shuffle: Boolean, // 用于执行洗牌动画
    flipAnime: Boolean // 用于执行翻盘动画
  },
  data () {
    return {
      startShuffle: false,
      animeTime: null,
      floatAnime: false
    }
  },
  computed: {
    CardList () {
      return this.setFlipCards()
    },
    getPrice () {
      let rewardPool = this.$bus.rewardPool
      let count = 0 // 已购买的数量
      let price = 0
      for (let item of rewardPool) {
        if (item.status === 1) {
          count++
        }
      }
      this.setCount(count)
      price = this.$bus.actInfo.spends[count]
      return price
    },
    getTip () {
      const [
        flipCostText,
        flipShuffleText,
        refreshText,
        refreshDone,
        canRefresh
      ] = [
        this.$bus.transify['FLIP_COST'],
        this.$bus.transify['FLIP_SHUFFLE_HINT'],
        this.$bus.transify['FLIP_REFRESH_POOL'],
        this.$bus.transify['FLIP_REFRESH_ALL_POOL'],
        this.$bus.actInfo.canRefresh
      ]
      if (this.shuffle) {
        return flipShuffleText
      } else {
        if (typeof this.getPrice === 'undefined') {
          return canRefresh ? refreshText : refreshDone
        } else {
          return flipCostText
        }
      }
    }
  },
  watch: {
    shuffle (val) {
      if (val) { // === true 执行洗牌动画, 都是新的一轮
        this.startShuffle = true
        this.floatAnime = true
        this.initShuffleAnime()
        setTimeout(() => {
          this.startShuffle = false
          this.playShuffleAnime()
        }, 2500)
      }
    }
  },
  methods: {
    isHasFlip () {
      if (!this.hasFlip) {
        this.hasFlip = true
      }
    },
    initShuffleAnime () {
      this.animeTime = anime.timeline('.flip-card-inner', () => {
        this.floatAnime = false
      }, () => {
        this.$bus.shuffleAnime = false
      })
      this.animeTime.add({
        targets: '.flip-card',
        rotateY: [0, '180deg'],
        duration: 600,
        easing: 'easeOutQuad'
      }).add({
        targets: '.flip-item-1',
        left: [0, '50%'],
        translateX: [0, '-55%'],
        duration: 800,
        easing: 'easeOutBack'
      }).add({
        targets: '.flip-item-3',
        right: [0, '50%'],
        translateX: [0, '55%'],
        duration: 800,
        easing: 'easeOutBack'
      }, '-=800').add({
        targets: '.flip-item-2',
        left: ['50%', '65%', '50%'],
        zIndex: [0, 1, 1],
        duration: 600,
        easing: 'easeOutQuad'
      }, '-=300').add({
        targets: '.flip-item-1',
        left: ['50%', '65%', '50%'],
        zIndex: [0, 2, 2],
        duration: 600,
        easing: 'easeOutQuad'
      }, '-=200').add({
        targets: '.flip-item-3',
        right: ['50%', '65%', '50%'],
        zIndex: [0, 3, 3],
        duration: 600,
        endDelay: 300,
        easing: 'easeOutQuad'
      }, '-=100').add({
        targets: '.flip-item-1',
        left: ['50%', 0],
        translateX: ['-55%', 0],
        zIndex: 0,
        duration: 800,
        easing: 'easeOutBack'
      }).add({
        targets: '.flip-item-2',
        zIndex: 0,
        duration: 800,
        easing: 'easeOutBack'
      }, '-=800').add({
        targets: '.flip-item-3',
        right: ['50%', 0],
        translateX: ['55%', 0],
        zIndex: 0,
        duration: 800,
        easing: 'easeOutBack'
      }, '-=800').add({
        targets: '.flip-item-btn',
        translateY: ['50%', 0],
        opacity: [0, 1],
        easing: 'easeOutBack'
      })
    },
    playShuffleAnime () {
      if (!this.$bus.skipAnime) { // 如果没有跳过动画
        this.animeTime.play() // 开始播放
      }
    },
    setCount (count) {
      this.$bus.nowCount = count + 1
    },
    setFlipCards () { // 设置翻牌数组
      return this.$bus.flipCards.sort(compare('index'))
    },
    flipCard (idx) {
      this.$bus.flipIdx = idx
      if (!this.shuffle && !this.flipAnime) {
        if (this.$bus.gems < this.getPrice) {
          this.$bus.handleToast(true, 'FLIP_GEM_NOT_ENOUGH')
          return false
        }
        this.$bus.nowPrice = this.getPrice
        this.$bus.flipNotice ? this.$bus.confirmDialog = {
          show: true,
          type: 'flip'
        } : this.$bus.flip()
      }
    },
    skipAnime () {
      this.$bus.skipAnime = !this.$bus.skipAnime
      localStorage.setItem(`${PROJECT_NAME}_skip_${this.$bus.uid}`, this.$bus.skipAnime)
      if (this.$bus.skipAnime) {
        if (this.animeTime) {
          this.animeTime.seek(10000)
        }
        this.$bus.addGA('skipAnime', 'success')
        this.startShuffle = false
        this.$bus.shuffleAnime = false
        this.$bus.firstLoad = false
        localStorage.setItem(`${PROJECT_NAME}_load_${this.$bus.uid}`, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flip-main {
  @include px2res(width, 980);
  @include flexcc;
  margin: 0 auto;
}
.flip-top {
  @include px2res(font-size, 36);
  @include px2res(height, 55);
  @include px2res(padding, 0, 18, 0, 0);
  @include flexrc;
  justify-content: space-between;
  width: 100%;
  text-transform: uppercase;
  font-style: italic;
  line-height: 1;
}
.flip-top-text {
  @include flexrc;
  color: #FFDBA7;
}
.flip-spend {
  color: #FFBB5B;
  @include flexrc;
  @include px2res(font-size, 50);
  @include px2res(margin, -8, 0, 0, 14);
}
.diamond {
  @include px2res(width, 24);
  @include px2res(height, 21);
  @include px2res(margin-left, 10);
}
.flip-skip-anime {
  @include flexrc;
  @include px2res(font-size, 30);
  color: #CCAF86;
}
.skip-text {
  @include px2res(margin-top, 4);
}
.skip-radio {
  @include px2res(width, 24);
  @include px2res(height, 24);
  @include px2res(margin-right, 14);
  background-size: 98% auto;
  position: relative;
}
.skip-radio::after {
  position: absolute;
  @include px2res(left, 0);
  @include px2res(bottom, 2);
  @include px2res(width, 35);
  @include px2res(height, 36);
}
.skip-radio.active::after {
  content: '';
}
.flip-card-inner {
  @include px2res(height, 536);
  @include px2res(margin-top, 10);
  width: 100%;
  position: relative;
}
.flip-item {
  @include flexcc;
  position: absolute;
  top: 0;
}
.flip-item:first-child {
  left: 0;
}
.flip-item:nth-child(2) {
  left: 50%;
  transform: translate(-50%, 0);
}
.flip-item:last-child {
  right: 0;
}
.flip-card {
  @include px2res(width, 296);
  @include px2res(height, 444);
  @include px2res(margin, 0, 6, 16);
}
.flip-card.front {
  transform: rotateY(0deg);
}
.flip-card.back {
  transform: rotateY(180deg);
}
.flip-btn-text {
  flex: auto;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue